import { apiClient } from '@lib/axios';

import type { UpdateProfileRequest, UpdateProfileResponse } from '../types';

export async function updateBusinessProfile(
  accountId: string,
  data: UpdateProfileRequest,
): Promise<UpdateProfileResponse> {
  const { data: response } = await apiClient.patch<UpdateProfileResponse>(
    `/settings/accounts/${accountId}/profile`,
    data,
  );
  return response;
}
